export default __webpack_public_path__ + "static/media/402.f9c1c0fc.jpg";